/**
 * Array of supported image MIME types.
 * Used for file upload validation and filtering.
 */
export const SUPPORTED_IMAGE_FORMATS = Object.freeze([
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/webp',
] as const);

export type SupportedImageFormat = (typeof SUPPORTED_IMAGE_FORMATS)[number];

/**
 * Maximum file size in bytes (20 MB).
 * Used for file upload size validation.
 */
export const MAX_FILE_SIZE_20_MB = 20971520;
